import { Alert, AlertColor } from '@mui/material';
import { EXTERNALPRODUCTPAGE } from '../../../../config/environment';
import {
  getCreditIdentification,
  getRemainingCredits,
} from '../../../../store/selectors/selectors';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

type Props = {
  creditIdentification: any;
  remainingCredits: number;
};

const CreditInfo: React.FC<Props> = ({ creditIdentification, remainingCredits }: Props) => {
  const { t } = useTranslation(['acceptReleaseRight']);

  const getSeverity = (): AlertColor => {
    if (remainingCredits <= 0 || creditIdentification.isExpired) return 'error';
    if (remainingCredits <= 10) return 'warning';
    return 'info';
  };

  const getCreditInfoText = (): string => {
    if (creditIdentification.isExpired) return t('acceptReleaseRight:creditInfo:expiredCredits');
    if (remainingCredits <= 0) return t('acceptReleaseRight:creditInfo:noCredits');
    if (remainingCredits <= 10)
      return remainingCredits + t('acceptReleaseRight:creditInfo:lowCredits');
    return remainingCredits + t('acceptReleaseRight:creditInfo:infoCredits');
  };

  return creditIdentification != null && !creditIdentification.hasPaidSubscription ? (
    <>
      <div>
        <Alert severity={getSeverity()}>
          {getCreditInfoText()}
          <br />
          <a href={EXTERNALPRODUCTPAGE} target="_new">
            Go to Portomundi Product Page
          </a>
        </Alert>
      </div>
    </>
  ) : (
    <></>
  );
};

function mapStateToProps(state: any) {
  return {
    creditIdentification: getCreditIdentification(state),
    remainingCredits: getRemainingCredits(state),
  };
}

export default connect(mapStateToProps)(CreditInfo as React.ComponentType<Props>);
